export const INCENTIVE_ID = "incentiveId";
export const DOCUSIGN_EVENT="event";
export const DOCUSIGN_SIGNING_COMPLETE="signing_complete";
export const DOCUSIGN_DECLINE="decline"; 
export const DOCUSIGN_TTL_EXPIRED="ttl_expired"; 
export const DOCUSIGN_SESSION_TIMEOUT="session_timeout"; 
export const ISLOCAL="IsLocal";
export const BANKING_ACCOUNT_NEEDS_UPDATING = "BankingAccountNeedsUpdating";
export const BANKING_ACCOUNT_UPDATE_FAILED = "BankingAccountUpdateFailed";
export const BILLING_API_ERROR = "BillingApiErrorAlert";
export const CONFIRMATION = "CONFIRMATION";